import LegalLayout from "@/components/mdh/LegalLayout";

export default function Terms() {
    return (
        <LegalLayout title="Terms of Service" updated="September 22, 2026" testid="terms-page">
            <p>
                These Terms of Service ("Terms") govern your access to and use of MDH-API
                ("MDH-API", "we", "the Service"), available at{" "}
                <a href="https://mdhapi.com">mdhapi.com</a>. By creating an account or using the
                Service, you agree to these Terms.
            </p>

            <h2>1. The Service</h2>
            <p>
                MDH-API is an event delivery and monitoring platform. It receives webhooks and
                events on your behalf, monitors endpoints and infrastructure you configure, and
                delivers alerts through the channels you enable (dashboard, email, and — if you opt
                in — SMS).
            </p>

            <h2>2. Accounts</h2>
            <p>
                You must provide accurate registration information and keep your credentials and
                API tokens confidential. You are responsible for activity that occurs under your
                account. You may sign up with an email address and password, or through Google or
                GitHub.
            </p>

            <h2>3. Acceptable use</h2>
            <p>
                You agree not to abuse the Service, attempt to gain unauthorized access to other
                accounts or systems, use the Service to send spam or unlawful content, or
                interfere with the Service's operation. We may suspend accounts that violate these
                Terms.
            </p>

            <h2>4. SMS notifications</h2>
            <p>
                SMS alerts are optional and require your explicit opt-in consent, collected through
                a dedicated, unchecked checkbox during registration or in your account settings.
                Consent is not required to create or use an account. Message frequency varies.
                Message and data rates may apply. You can opt out at any time by replying STOP to
                any message, or by disabling SMS notifications in your account settings. Reply HELP
                for assistance.
            </p>

            <h2>5. Your data</h2>
            <p>
                You retain ownership of the data you send through the Service. Our handling of
                personal information is described in the{" "}
                <a href="/privacy">Privacy Policy</a>.
            </p>

            <h2>6. Availability</h2>
            <p>
                We work hard to keep the Service reliable but provide it "as is" without a service
                level guarantee. Features may change over time; material changes to these Terms
                will be announced through the Service.
            </p>

            <h2>7. Limitation of liability</h2>
            <p>
                To the maximum extent permitted by law, MDH-API is not liable for indirect,
                incidental, or consequential damages arising from your use of the Service.
            </p>

            <h2>8. Contact</h2>
            <p>
                Questions about these Terms: <a href="mailto:support@mdhapi.com">support@mdhapi.com</a>.
            </p>
        </LegalLayout>
    );
}
